import React, { useState } from 'react';
import { toast } from 'react-toastify';
import "./Models.css";
const Modals = ({
  isDeleteChatConfirmOpen,
  setIsDeleteChatConfirmOpen,
  handleDeleteChat,
  isDeletingChat,
  isPrivacyOpen,
  setIsPrivacyOpen,
  isLogoutConfirmOpen,
  setIsLogoutConfirmOpen,
  handleLogout,
  isViewModalOpen,
  setIsViewModalOpen,
  selectedTask,
  setSelectedTask,
  isEditMode,
  setIsEditMode,
  handleSaveEdit,
  isSupportOpen,
  setIsSupportOpen,
  isModalOpen,
  setIsModalOpen,
  newTask,
  setNewTask,
  handleAddTask,
  handleAIMagic,
  isAiLoading,
  isSavingTask,
  isEditingSaving
}) => {
  const [dateError, setDateError] = useState('');
  const [createDateError, setCreateDateError] = useState('');
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const [isListening, setIsListening] = useState(false);
  const [editTitleError, setEditTitleError] = useState('');

  const handleLogoutWithLoading = () => {
    setIsLoggingOut(true);
    setTimeout(() => {
      handleLogout();
      setIsLoggingOut(false);
      setIsLogoutConfirmOpen(false);
    }, 2500); // 2.5 seconds loading
  };

  const getDateInputValue = (value) => {
    if (!value) return '';
    if (typeof value === 'string') {
      return value.includes('T') ? value.split('T')[0] : value;
    }
    const parsed = new Date(value);
    if (Number.isNaN(parsed.getTime())) return '';
    return parsed.toISOString().split('T')[0];
  };

  const resetNewTaskForm = () => {
    setNewTask({
      title: '',
      description: '',
      due_date: ''
    });
    setCreateDateError('');
  };

  // Handle Voice Input
  const handleVoiceInput = () => {
    if (!('webkitSpeechRecognition' in window) && !('SpeechRecognition' in window)) {
      toast.error('Voice input not supported in this browser. Try Chrome or Firefox.');
      return;
    }
    const recognition = new (window.SpeechRecognition || window.webkitSpeechRecognition)();
    recognition.continuous = false;
    recognition.interimResults = false;
    recognition.lang = 'en-US';

    recognition.onstart = () => setIsListening(true);
    recognition.onend = () => setIsListening(false);
    recognition.onresult = (event) => {
      const transcript = event.results[0][0].transcript;
      setNewTask({ ...newTask, title: transcript });
    };
    
    recognition.onerror = (event) => {
      let errorMessage = 'Voice recognition failed.';
      switch (event.error) {
        case 'no-speech':
          errorMessage = 'No speech detected';
          break;
        case 'audio-capture':
          errorMessage = 'Microphone access failed. Check your microphone settings.';
          break;
        case 'not-allowed':
          errorMessage = 'Microphone permission denied. Please allow microphone access.';
          break;
        case 'network':
          errorMessage = 'Network error. Check your internet connection.';
          break;
        case 'service-not-allowed':
          errorMessage = 'Speech recognition service not available.';
          break;
        default:
          errorMessage = `Voice recognition error: ${event.error}`;
      }
      toast.error(errorMessage);
      setIsListening(false);
    };

    recognition.start();
  };
  return (
    <>
            {/* Delete Chat Confirmation Modal */}
            {isDeleteChatConfirmOpen && (
              <div className="modal-overlay" onClick={() => setIsDeleteChatConfirmOpen(false)}>
                <div
                  className="modal-content ultra-glass delete-chat-modal"
                  style={{
                    maxWidth: '400px',
                    textAlign: 'center',
                    padding: '40px',
                    border: '1px solid rgba(255, 255, 255, 0.1)'
                  }}
                  onClick={(e) => e.stopPropagation()}
                >
                  <button className="close-btn" onClick={() => setIsDeleteChatConfirmOpen(false)}>✕</button>
                  <h3 className="modal-title" style={{ marginBottom: '15px' }}>Delete Chat</h3>
                  <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: '14px', marginBottom: '30px', lineHeight: '1.5' }}>
                    Are you sure you want to delete your chat history? <br/>
                    This action cannot be undone.
                  </p>
                  <div style={{ display: 'flex', gap: '15px', justifyContent: 'center' }}>
                    <button
                      className="save-btn cancel-btn"
                      onClick={() => setIsDeleteChatConfirmOpen(false)}
                      style={{ flex: 1, cursor: 'pointer' }}
                    >
                      CANCEL
                    </button>
                        <button
                          className="save-btn delete-chat-btn"
                          onClick={handleDeleteChat}
                          style={{ flex: 1, cursor: isDeletingChat ? 'not-allowed' : 'pointer', opacity: isDeletingChat ? 0.7 : 1 }}
                          disabled={isDeletingChat}
                        >
                          {isDeletingChat ? (
                            <div style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}>
                              <div style={{
                                width: '18px',
                                height: '18px',
                                border: '2px solid rgba(255, 255, 255, 0.3)',
                                borderTop: '2px solid #fff',
                                borderRadius: '50%',
                                animation: 'spin 1s linear infinite'
                              }} />
                            </div>
                          ) : (
                            <>
                              DELETE
                            </>
                          )}
                        </button>
                  </div>
                </div>
              </div>
            )}
      {/* Privacy Modal */}
      {isPrivacyOpen && (
        <div className="modal-overlay" onClick={() => setIsPrivacyOpen(false)}>
          <div
            className="modal-content ultra-glass"
            style={{
              maxWidth: '1000px',
              width: '90%',
              textAlign: 'center',
              padding: '40px'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <button className="close-btn" onClick={() => setIsPrivacyOpen(false)}>✕</button>

            <h3 className="modal-title" style={{ marginBottom: '30px' }}>Privacy & Security</h3>

            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(3, 1fr)',
              gap: '20px',
              marginBottom: '30px'
            }}>
              {/* Box 1 */}
              <div style={{ padding: '20px', background: 'rgba(255,255,255,0.03)', borderRadius: '15px', border: '1px solid rgba(255,255,255,0.05)' }}>
                <h4 style={{ color: '#fff', marginBottom: '10px', fontSize: '15px' }}>ENCRYPTION</h4>
                <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: '13px', lineHeight: '1.5' }}>
                  Military-grade 256-bit AES protocols ensure your data remains indecipherable.
                </p>
              </div>

              {/* Box 2 */}
              <div style={{ padding: '20px', background: 'rgba(255,255,255,0.03)', borderRadius: '15px', border: '1px solid rgba(255,255,255,0.05)' }}>
                <h4 style={{ color: '#fff', marginBottom: '10px', fontSize: '15px' }}>ZERO-SHARE</h4>
                <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: '13px', lineHeight: '1.5' }}>
                  Isolated environment ensures your data is never shared with third-party networks.
                </p>
              </div>

              {/* Box 3 */}
              <div style={{ padding: '20px', background: 'rgba(255,255,255,0.03)', borderRadius: '15px', border: '1px solid rgba(255,255,255,0.05)' }}>
                <h4 style={{ color: '#fff', marginBottom: '10px', fontSize: '15px' }}>COMPLIANCE</h4>
                <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: '13px', lineHeight: '1.5' }}>
                  Modern protection standards with secure session management and XSS mitigation.
                </p>
              </div>
            </div>

            <button
              className="save-btn"
              onClick={() => setIsPrivacyOpen(false)}
              style={{ width: '200px', margin: '0 auto' }}
            >
              ACKNOWLEDGE
            </button>
          </div>
        </div>
      )}

      {/* Logout Confirmation Modal */}
      {isLogoutConfirmOpen && (
        <div className="modal-overlay" onClick={() => setIsLogoutConfirmOpen(false)}>
          <div
            className="modal-content ultra-glass"
            style={{
              maxWidth: '400px',
              textAlign: 'center',
              padding: '40px',
              border: '1px solid rgba(255, 255, 255, 0.1)'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <button className="close-btn" onClick={() => setIsLogoutConfirmOpen(false)}>✕</button>

            <h3 className="modal-title" style={{ marginBottom: '15px' }}>Logout</h3>

            <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: '14px', marginBottom: '30px', lineHeight: '1.5' }}>
              Are you sure you want to end your current session? <br/>
              Any unsaved changes will be lost.
            </p>

            <div style={{ display: 'flex', gap: '15px', justifyContent: 'center' }}>
              {/* Cancel Button */}
              <button
                className="save-btn"
                onClick={() => setIsLogoutConfirmOpen(false)}
                style={{ background: 'rgba(255,255,255,0.05)', flex: 1, cursor: 'pointer' }}
              >
                CANCEL
              </button>

              {/* Real Logout Button */}
              <button
                className="save-btn"
                onClick={handleLogoutWithLoading}
                disabled={isLoggingOut}
                style={{ 
                  background: isLoggingOut ? 'rgba(255, 75, 43, 0.7)' : '#ff4b2b', 
                  color: '#fff', 
                  border: 'none', 
                  flex: 1, 
                  cursor: isLoggingOut ? 'not-allowed' : 'pointer',
                  opacity: isLoggingOut ? 0.8 : 1,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '10px',
                  minHeight: '45px'
                }}
              >
                {isLoggingOut ? (
                  <div style={{
                    width: '18px',
                    height: '18px',
                    border: '2px solid rgba(255, 255, 255, 0.3)',
                    borderTop: '2px solid #fff',
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite'
                  }}></div>
                ) : 'LOGOUT'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Task Detail & Edit Modal */}
      {isViewModalOpen && selectedTask && (
        <div className="modal-overlay" onClick={() => setIsViewModalOpen(false)}>
          <div
            className="modal-content ultra-glass"
            onClick={(e) => e.stopPropagation()}
          >
            <button className="close-btn" onClick={() => {
              setIsViewModalOpen(false);
              setDateError('');
            }}>✕</button>

            <h3 className="modal-title" style={{ marginBottom: '25px', textTransform: 'uppercase' }}>
              {isEditMode ? "Edit  Task  Config" : "Task  Info"}
            </h3>

            {isEditMode ? (
              <form className="add-task-form-popup">
                <div className="form-group">
                  <label>Title</label>
                  <input
                    type="text"
                    placeholder="Enter task title"
                    value={selectedTask.title}
                    onChange={(e) => {
                      const nextTitle = e.target.value;
                      setSelectedTask({...selectedTask, title: nextTitle});
                      setEditTitleError(nextTitle.trim() ? '' : 'Please fill in this field');
                    }}
                    required
                  />
                  {editTitleError && (
                    <p style={{
                      color: '#ff6b6b',
                      fontSize: '12px',
                      marginTop: '5px',
                      fontWeight: '500'
                    }}>
                      {editTitleError}
                    </p>
                  )}
                </div>
                <div className="form-group">
                  <label>Description</label>
                  <textarea
                    className="fixed-desc-area"
                    placeholder="Enter task details"
                    value={selectedTask.description}
                    onChange={(e) => setSelectedTask({...selectedTask, description: e.target.value})}
                  />
                </div>
                <div className="form-group">
                  <label>Due Date</label>
                  <input
                    type="date"
                    value={getDateInputValue(selectedTask.due_date)}
                    onChange={(e) => {
                      const selectedDate = e.target.value;
                      if (!selectedDate) {
                        setDateError('Please select a due date');
                      } else {
                        const today = new Date();
                        today.setHours(0, 0, 0, 0); // Reset time to start of day
                        const selectedDateObj = new Date(selectedDate);
                        
                        if (selectedDateObj < today) {
                          setDateError('Past dates are not allowed');
                        } else {
                          setDateError('');
                        }
                      }
                      setSelectedTask({...selectedTask, due_date: selectedDate});
                    }}
                    required
                  />
                  {dateError && (
                    <p style={{ 
                      color: '#ff6b6b', 
                      fontSize: '12px', 
                      marginTop: '5px',
                      fontWeight: '500'
                    }}>
                      {dateError}
                    </p>
                  )}
                </div>
                <button
                  type="button"
                  className="save-btn"
                  onClick={() => {
                    const titleValue = (selectedTask?.title || '').trim();
                    const dueDateValue = selectedTask?.due_date || '';
                    if (!titleValue) {
                      setEditTitleError('Please fill in this field');
                    }
                    if (!dueDateValue) {
                      setDateError('Please select a due date');
                    }
                    if (!titleValue || !dueDateValue || dateError) return;
                    handleSaveEdit();
                  }}
                  disabled={isEditingSaving || !!dateError || !!editTitleError}
                  style={{
                    opacity: (isEditingSaving || dateError || editTitleError) ? 0.5 : 1,
                    cursor: (isEditingSaving || dateError || editTitleError) ? 'not-allowed' : 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '10px'
                  }}
                >
                  {isEditingSaving ? (
                    <div style={{
                      width: '16px',
                      height: '16px',
                      border: '2px solid rgba(255, 255, 255, 0.3)',
                      borderTop: '2px solid #fff',
                      borderRadius: '50%',
                      animation: 'spin 1s linear infinite'
                    }}></div>
                  ) : "SAVE UPDATES"}
                </button>
              </form>
            ) : (
              <>
                <div className="form-group" style={{ textAlign: 'left', marginBottom: '15px' }}>
                  <label style={{ color: '#00e0ff', fontSize: '11px', fontWeight: '800', letterSpacing: '1px' }}>TASK TITLE</label>
                  <p style={{ color: '#fff', fontSize: '18px', marginTop: '10px', fontWeight: '600', margin: '0' }}>{selectedTask.title}</p>
                </div>

                <div className="form-group" style={{ textAlign: 'left', marginBottom: '15px', maxHeight: '200px', overflowY: 'auto', paddingRight: '8px' }}>
                  <label style={{ color: '#00e0ff', fontSize: '11px', fontWeight: '800', letterSpacing: '1px' }}>DESCRIPTION</label>
                  <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: '14px', lineHeight: '1.6', margin: '10px 0 0 0', whiteSpace: 'pre-wrap', wordWrap: 'break-word' }}>
                    {selectedTask.description || "No metadata provided."}
                  </p>
                </div>

                <div className="form-group" style={{ textAlign: 'left', marginBottom: '20px' }}>
                  <label style={{ color: '#00e0ff', fontSize: '11px', fontWeight: '800', letterSpacing: '1px' }}>DUE DATE</label>
                  <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: '14px', marginTop: '10px', margin: '0' }}>
                    {selectedTask.due_date ? new Date(selectedTask.due_date).toLocaleDateString() : "No due date set"}
                  </p>
                </div>

                <button className="save-btn" onClick={() => {
                  setIsEditMode(true);
                  setDateError('');
                  setEditTitleError('');
                }}>EDIT TASK</button>
              </>
            )}
          </div>
        </div>
      )}

      {/* Support Modal */}
      {isSupportOpen && (
        <div className="modal-overlay" style={{ pointerEvents: 'auto' }}>
          <div
            className="modal-content ultra-glass"
            onClick={(e) => e.stopPropagation()}
            style={{ pointerEvents: 'auto', position: 'relative' }}
          >
            <button className="close-btn" onClick={() => setIsSupportOpen(false)}>✕</button>

            <h3 className="modal-title">SYSTEM SUPPORT</h3>
            <p style={{ color: 'rgba(255, 255, 255, 0.96)', marginBottom: '30px' }}>
              NEED HELP?
            </p>

            <div className="support-options" style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>


        {/* --- PROFESSIONAL AUTO-MESSAGE WHATSAPP --- */}
      <a
        href="https://wa.me/923248846898?text=TODO%20TEAM%20%7C%20SUPPORT%20REQUEST%0A---------------------------------------%0AHello%20Todo%20Team%2C%0A%0AI%20am%20using%20the%20Task%20Management%20app%20and%20I%20need%20some%20assistance%20with%20the%20system.%0APlease%20get%20back%20to%20me%20as%20soon%20as%20possible."
        target="_blank"
        rel="noopener noreferrer"
        className="save-btn"
        style={{
          background: 'rgba(14, 94, 67, 0.43)',
          cursor: 'pointer',
          textAlign: 'center',
          border: '1px solid rgba(0, 8, 6, 0.2)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          textDecoration: 'none',
          color: '#ffffff',
          fontWeight: '500',
          padding: '12px',
          borderRadius: '8px'
        }}
      >
        Contact Via Whatsapp
      </a>

        {/* Contact via Email (Direct Gmail Link) */}
        <div
          className="save-btn"
          style={{ background: 'rgba(255, 255, 255, 0.1)', cursor: 'pointer', textAlign: 'center' }}
          onClick={() => {
            const email = "contactzainch@gmail.com";
            const subject = "Support Request";
            // Ye direct Gmail kholta hai browser mein
            window.open(`https://mail.google.com/mail/?view=cm&fs=1&to=${email}&su=${subject}`, '_blank');
          }}
        >
          Send Email (Gmail)
        </div>

      </div>
          </div>
        </div>
      )}

      {/* Add Task Modal */}
      {isModalOpen && (
        <div className="modal-overlay" onClick={() => {
          setIsModalOpen(false);
          resetNewTaskForm();
        }}>
          <div className="modal-content ultra-glass" onClick={(e) => e.stopPropagation()}>
            <button className="close-btn" onClick={() => {
              setIsModalOpen(false);
              resetNewTaskForm();
            }}>✕</button>
            <h3 className="modal-title">New Task</h3>
            <form onSubmit={handleAddTask} className="add-task-form-popup">
              <div className="form-group">
                <label>Title</label>
                <div className="input-with-voice">
                  <input type="text" placeholder="Enter task title" value={newTask.title} onChange={(e) => setNewTask({...newTask, title: e.target.value})} required />
                  <button
                    type="button"
                    className={`voice-mic-btn ${isListening ? 'listening' : ''}`}
                    onClick={handleVoiceInput}
                    title="Voice input for title"
                  >
                    🎤
                  </button>
                  <button type="button" className={`ai-magic-btn ${isAiLoading ? 'loading' : ''}`} onClick={handleAIMagic} disabled={isAiLoading}>
                    {isAiLoading ? "Processing..." : <><span>Auto</span><span>Description</span></>}
                  </button>
                </div>
              </div>
              <div className="form-group">
                <label>Description</label>
                <textarea 
                  className="fixed-desc-area" 
                  placeholder="Enter task description" 
                  value={newTask.description} 
                  onChange={(e) => {
                    const descSize = new Blob([e.target.value]).size;
                    if (descSize > 1048576) { // 1MB limit
                      return; // Prevent adding more
                    }
                    setNewTask({...newTask, description: e.target.value});
                  }} 
                />
              </div>
              <div className="form-group">
                <label>Due Date</label>
                <input 
                  type="date" 
                  value={newTask.due_date} 
                  onChange={(e) => {
                    const selectedDate = e.target.value;
                    if (selectedDate) {
                      const today = new Date();
                      today.setHours(0, 0, 0, 0); // Reset time to start of day
                      const selectedDateObj = new Date(selectedDate);
                      
                      if (selectedDateObj < today) {
                        setCreateDateError('Past dates are not allowed');
                      } else {
                        setCreateDateError('');
                      }
                    } else {
                      setCreateDateError('');
                    }
                    setNewTask({...newTask, due_date: selectedDate});
                  }} 
                  required 
                />
                {createDateError && (
                  <p style={{ 
                    color: '#ff6b6b', 
                    fontSize: '12px', 
                    marginTop: '5px',
                    fontWeight: '500'
                  }}>
                    {createDateError}
                  </p>
                )}
              </div>
              <button 
                type="submit" 
                className="save-btn"
                disabled={isSavingTask || !!createDateError}
                style={{
                  opacity: (isSavingTask || createDateError) ? 0.5 : 1,
                  cursor: (isSavingTask || createDateError) ? 'not-allowed' : 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '10px'
                }}
              >
                {isSavingTask ? (
                  <div style={{
                    width: '16px',
                    height: '16px',
                    border: '2px solid rgba(255, 255, 255, 0.3)',
                    borderTop: '2px solid #fff',
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite'
                  }}></div>
                ) : "Save Task"}
              </button>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default Modals;